// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ServiceabilityRepoConfig from "./ServiceabilityRepoConfig.bs.js";

function getServiceabilityURLParams(serviceabilityOffset) {
  var dict = {};
  dict["offset_value"] = Belt_Option.mapWithDefault(serviceabilityOffset, "", (function (prim) {
          return String(prim);
        }));
  return dict;
}

function getHelperServiceabilityInfo(msisdn, offset, country) {
  var urlParams = getServiceabilityURLParams(offset);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/" + (msisdn + "/helper_serviceability/"), urlParams);
  return CrmNetwork.get(requestUrl, "/administrators/:msisdn/helper_serviceability", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.HelperServiceabilityResponseConverter.execute, result);
                        });
            });
}

function getOutStationServiceabilityInfo(msisdn, offset, country) {
  var urlParams = getServiceabilityURLParams(offset);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/" + (msisdn + "/outstation_serviceability/"), urlParams);
  return CrmNetwork.get(requestUrl, "/administrators/:msisdn/outstation_serviceability", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.OutStationServiceabilityResponseConverter.execute, result);
                        });
            });
}

function getRentalServiceabilityInfo(msisdn, offset, country) {
  var urlParams = getServiceabilityURLParams(offset);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/" + (msisdn + "/rental_serviceability/"), urlParams);
  return CrmNetwork.get(requestUrl, "/administrators/:msisdn/rental_serviceability", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.RentalServiceabilityResponseConverter.execute, result);
                        });
            });
}

function fetchHelperLabourServiceability(msisdn, offset, country) {
  var urlParams = getServiceabilityURLParams(offset);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/" + (msisdn + "/labour_serviceability/"), urlParams);
  return CrmNetwork.get(requestUrl, "/administrators/:msisdn/labour_serviceability", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.HelperLabourServiceabilityResponseConverter.execute, result);
                        });
            });
}

var ServiceabilityRepo = {
  getHelperServiceabilityInfo: getHelperServiceabilityInfo,
  getOutStationServiceabilityInfo: getOutStationServiceabilityInfo,
  fetchHelperLabourServiceability: fetchHelperLabourServiceability,
  getRentalServiceabilityInfo: getRentalServiceabilityInfo
};

export {
  ServiceabilityRepo ,
  
}
/* Config Not a pure module */
